import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/Divar.css';
import ls from 'local-storage'
import axios from 'axios';
import Retry from "./Retry";
import AppBody from "./AppBody";
import DivarItem from "../Modules/DivarItem";

class Divar extends React.Component{
    list =[];
    hasMoreItemsToLoad = true;
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            activeMenu: 0,
            cat_id: "",
            page: 1,
            retry: false,
            error: false,
            error_text: "",
            loading: true,
            items: [],
            Category: [{id:"",cat_name:"همه"}],
        };
        this.handleCategoryClick = this.handleCategoryClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }
    componentWillMount() {

    }
    componentDidMount = () => {
        let target = document.getElementById("topCategories");
        target.addEventListener('wheel', event => {
            let toLeft  = event.deltaY > 0 && target.scrollLeft > 0;
            let toRight = event.deltaY < 0 && target.scrollLeft < target.scrollWidth - target.clientWidth ;

            if (toLeft || toRight) {
                event.preventDefault();
                target.scrollLeft -= event.deltaY;
            }
        });

        this.content = document.getElementsByClassName("content")[0];
        this.getDivarItems();
        this.content.addEventListener("scroll",this.handleScroll,false);
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );
        return (
            <AppBody loading={this.state.loading} name={"دیوار"} type={" alice"}>
                {this.renderCategories()}
                {this.renderItems()}
            </AppBody>
        );
    }
    renderCategories(){
        return (
            <div id={"topCategories"} >
                {this.state.Category.map((cat)=>{
                   return (
                       <div className={"topCatItem"+((this.state.cat_id == cat.cat_id)?" active":"")} onClick={(this.state.cat_id != cat.cat_id)?()=>this.handleCategoryClick(cat.cat_id):()=>this.handleCategoryClick()}>
                           {cat.cat_name}
                       </div>
                   )
                })}
            </div>
        )
    }

    renderItems(){
        return this.state.items.map((item)=>{
            return(
                <div className={"divarItem"}>
                    <div className={"divarImgDiv"}>
                        <img className={"divarImg"} src={(item.img!= null)?"http://asooone.ir/upload/divar/"+item.img:""}/>
                        <div className={"divarPrice"}>{(item.tavafoghi == 1)?"توافقی":new Intl.NumberFormat("fa").format(item.price)+" تومان"}</div>
                    </div>
                    <div className={"divarInfo"}>
                        <div className={"divarTitle"}>{item.title}</div>
                        <div  dangerouslySetInnerHTML={{__html: item.text}}  className={"divarText"}/>
                        <div className={"divarDate"}>{item.date}</div>
                    </div>
                    </div>
            );
        })
    }


    handleCategoryClick(id){
        if(id != null)
            this.setState({cat_id:id,page:1},() => {
                this.getDivarItems();
            });
        else
            console.log(id);
    }
    getDivarItems(clearSubChild = true){
        this.setState({loading:true});
        let subCats = this.state.SubChildCategory;
        if(clearSubChild)
            subCats = [];
        if(this.state.page === 1)
            this.setState({ items: []});
        axios.get(urls.baseUrl+urls.getDivarList+"?"
            + "cat_id=" +this.state.cat_id
            +"&page="+this.state.page
            +"&token="+ls.get("token")
            +"&city_id="+ls.get("city_id")
        )
            .then(res => {
                console.log("divar : ",res.data);
                if(res.data.code == 200){
                    if(res.data.divar.data.length === 0)
                        this.hasMoreItemsToLoad = false;
                    else
                        this.hasMoreItemsToLoad = true;

                    let cats = [];
                    cats.push({cat_id:"",cat_name:"همه"});
                    cats = [...cats,...res.data.catDivar];
                    let items = [];
                    res.data.divar.data.forEach((item)=>{
                        let it = new DivarItem();
                        it.setData(item);
                        items.push(it);
                    });
                    console.log("Items",items);
                    this.setState({
                        items:[...this.state.items, ...items],
                        Category:cats,
                        loading:false},()=>{
                        this.content.addEventListener("scroll",this.handleScroll,false);
                    });

                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false},()=>{
                    this.content.addEventListener("scroll",this.handleScroll,false);
                });
            });


    }
    handleScroll = (event) => {
        if(!this.hasMoreItemsToLoad){
            event.target.removeEventListener("scroll", this.handleScroll);
            return;
        }

        if(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 2 && !this.isLoadingMore){
            event.target.removeEventListener("scroll", this.handleScroll);

            this.setState({page:this.state.page+1},() => {
                this.getDivarItems();
            })
        }
    };
}



export default Divar;
